import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { EditComponent } from '@app/common/templates/edit/edit.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
	templateUrl: '../../../../common/templates/edit/edit.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/edit/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblFirmaEditComponent extends EditComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public dialogService: DialogService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public translate: TranslateService,
	) {
		super(accountService, breadcrumbService, confirmationService, crudService, dialogService, globals, messageService, router, translate);

		this.apiUrl = 'TblFirma';
		this.name = 'MENU.FIRMA';
		this.url = '/' + PATH.FIRMA;
		this.fieldgroups.push(
			[
				{ type: 'text', key: 'ankey', required: true, width: 400 },
				{ type: 'text', key: 'bezeichnung', required: true, width: 400, maxLength: 250 },
				{ type: 'text', key: 'bezeichnung_kurz', required: false, width: 400, maxLength: 32 },
				{ type: 'text', key: 'ansprechpartner', required: false, width: 400, maxLength: 64 },
				{ type: 'text', key: 'url', required: false, width: 400, maxLength: 64 },
				{ type: 'text', key: 'email', required: false, width: 400, maxLength: 64 },
				{ type: 'text', key: 'fax', required: false, width: 400, maxLength: 32 },
				{ type: 'text', key: 'telefon1', required: false, width: 400, maxLength: 32 },
				{ type: 'text', key: 'land', required: false, width: 400, maxLength: 64 },
				{ type: 'text', key: 'plz', required: false, width: 400, maxLength: 32 },
				{ type: 'village', key: 'ort', required: false, width: 400, plz_field: 'plz' },
				{ type: 'text', key: 'hausnummer', required: false, width: 400, maxLength: 32 },
				{ type: 'text', key: 'strasse', required: false, width: 400, maxLength: 64 },
			]
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.BHV' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.EDIT', routerLink: [this.url + '/' + PATH.EDIT + '/' + this.id] }
		]);
	}
}
